export default __webpack_public_path__ + "static/media/searchIcon.676993e9.svg";